function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.75 1.75a2 2 0 00-2 2v18.5a2 2 0 002 2h24.5a2 2 0 002-2V3.75a2 2 0 00-2-2H3.75z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M8.75 29c0-.69.56-1.25 1.25-1.25h12a1.25 1.25 0 110 2.5H10c-.69 0-1.25-.56-1.25-1.25z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.764 12.748c.35-.05.414-.529.089-.668L10.919 7.394a.4.4 0 00-.525.525l4.686 10.934c.14.325.618.262.668-.089l.715-5.004a.35.35 0 01.297-.297l5.004-.715z",
  fill: "url(#application_svg__paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "application_svg__paint0_linear",
  x1: 12.555,
  y1: 7.36,
  x2: 21.688,
  y2: 9.449,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgApplication = function SvgApplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgApplication;